// Cores do ProfileScreen, geradas a partir do tema (claro/escuro).
// Extraído do ProfileScreen para ser compartilhado entre a tela e seus estilos.
export const getColors = (isDarkMode) => ({
  bgPrimary: isDarkMode ? '#0B0D17' : '#F5F7FA',
  bgSecondary: isDarkMode ? '#151821' : '#FFFFFF',
  bgTertiary: isDarkMode ? '#1E2029' : '#E8EDF2',
  bgCard: isDarkMode ? '#252832' : '#FFFFFF',
  textPrimary: isDarkMode ? '#E8EAED' : '#1A1A2E',
  textSecondary: isDarkMode ? '#A0A3B1' : '#4A5568',
  textTertiary: isDarkMode ? '#6B6E7B' : '#718096',
  accentPrimary: isDarkMode ? '#5B8FF9' : '#4299E1',
  accentSuccess: '#51CF66',
  accentWarning: '#FFD93D',
  accentPurple: '#9F7AEA',
  accentOrange: '#FF9F43',
  border: isDarkMode ? '#2A2D3A' : '#E2E8F0',
});
